import renderComponent from './renderComponent.js';
import text from '../constants.js';
import { countAnswer, createElement } from '../utils.js';
import renderIcon from './renderIcon.js';

export default function renderInput (componentElement, props, data, obj) {
    const answerElement = renderComponent(componentElement, props, data, obj); 
    if(obj.mode <= 2){
        const element = props.type == 'textarea' ? 'textarea' : 'input';
        let el;
        if(obj.mode == 1 && props.type == 'file'){
            el = createElement('div', {
                className: 'x-upload',
                innerHTML: renderIcon('file') + '<br />Upload File'
            })
        } else {
            el = createElement(element, {
                className: 'x-answer-input x-preview',
                value: obj.mode == 1 ? (data.correct_answer || '') : (data.answer || ''),
                placeholder: text.ANSWER,
                name: data.id
            });
            if (props.type != 'textarea') el.type = props.type;    
        }  
        
        el.addEventListener('change', e => countAnswer(e, obj) );
        answerElement.appendChild(el);                
    } else {
        answerElement.classList.add('x-view');
        answerElement.innerHTML = `${data.answer || ''}`;
    }
}